import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type IconComponent = React.ComponentType<
  React.SVGProps<SVGSVGElement> & { size?: number }
>;

export type EmptyStateProps = {
  /** Duotone icon shown above the title. */
  icon?: IconComponent;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Optional call-to-action rendered as a Button. */
  action?: { label: React.ReactNode; onClick: () => void };
  className?: string;
};

/**
 * Neutral empty/zero-data placeholder for list surfaces (invoices, messages,
 * submissions, reports…). Render inside a `wh-ui` scope.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  className,
}) => (
  <div
    className={cn(
      'flex w-full flex-col items-center gap-3 rounded-lg border border-dashed border-border bg-secondary/40 px-6 py-12 text-center',
      className
    )}
  >
    {Icon && <Icon size={32} className="text-muted-foreground" />}
    <div className="flex flex-col gap-1">
      <p className="text-base font-medium text-balance text-foreground">
        {title}
      </p>
      {description && (
        <p className="text-sm text-pretty text-muted-foreground">
          {description}
        </p>
      )}
    </div>
    {action && (
      <Button type="button" variant="outline" onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
);
